<template>
  <h1 class="VB_Brochure_Title">
    <span>{{ videoTitle }}</span>
  </h1>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      videoTitle: "pageTitle"
    })
  }
};
</script>

<style lang="scss">
.VB_Brochure_Title {
  position: absolute;
  font-family: helvetica, arial, san-serif;
  left: 24pt;
  top: 74pt;
  right: 24pt;
  margin: auto;
  box-sizing: border-box;
  background: black;
  color: white;
  line-height: 1.3;
  font-size: 8pt;
  padding: 3pt 0;
  font-weight: 700;
  text-align: center;

  @media print {
    background: black;
    color: white;
    -webkit-print-color-adjust: exact;
  }
}
</style>
